var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _ellipse5, _ellipse6, _ellipse7, _ellipse8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-6.212 96.651 75.058)",
    cx: 96.65,
    cy: 75.06,
    rx: 7.46,
    ry: 10.19,
    fill: "#176bc6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-3.438 45.482 24.473)",
    cx: 45.49,
    cy: 24.46,
    rx: 7.7,
    ry: 10.06,
    fill: "#176bc6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-83.131 62.972 30.562)",
    cx: 62.97,
    cy: 30.56,
    rx: 9.6,
    ry: 7.7,
    fill: "#176bc6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-13.239 27.21 27.8)",
    cx: 27.21,
    cy: 27.8,
    rx: 7.83,
    ry: 10.74,
    fill: "#176bc6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.66 94.36c15.11-8.45 32.4 3.47 30.13 12.58c-2.44 9.76-11.73 4.5-18.68 7.04c-4.27 1.56-10.79 10.32-18.3 4.97c-6.55-4.67-3.01-19.08 6.85-24.59z",
    fill: "#176bc6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.16 40.41c10.8-2.83 25.86 5.56 24.14 15.13c-1.62 9.01-14.14 5.08-19.22 6.97c-6.62 2.46-14.92 9.71-19.64 2.46c-5.32-8.19 5.24-22.07 14.72-24.56z",
    fill: "#176bc6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-30 12.909 40.928)",
    cx: 12.91,
    cy: 40.93,
    rx: 7.71,
    ry: 9.95,
    fill: "#176bc6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-30 79.075 82.363)",
    cx: 79.08,
    cy: 82.36,
    rx: 8.01,
    ry: 10.19,
    fill: "#176bc6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-35.353 67.223 97.302)",
    cx: 67.22,
    cy: 97.3,
    rx: 7.46,
    ry: 10.19,
    fill: "#176bc6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-3.533 115.05 78.335)",
    cx: 115.06,
    cy: 78.32,
    rx: 7.43,
    ry: 9.46,
    fill: "#176bc6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.39da4fd45a3326de08666aab85eacf2c.svg";
export { ForwardRef as ReactComponent };